export const setData = data => ({
  type: "SET_DATA",
  data
});

export const fetchData = data => ({
  type: "FETCH_DATA",
  payload: data
});

export const setOrganizationsList = organizations => {
  return {
    type: "SET_ORGANIZATIONS_LIST",
    organizations
  };
};

export const fetchOrganizations = resp => {
  return {
    type: "FETCH_ORGANIZATIONS_LIST",
    payload: resp
  };
};

export const setOrganizationListFilterImportedBalance = importedBalance => {
  return {
    type: "FETCH_ORGANIZATIONS_LIST_FILTER_IMPORTED_BALANCE",
    importedBalance
  };
};

// Just a hack to resolve quickly the fetching of Fiche client
export const fetchFicheClient = resp => {
  return {
    type: "FETCH_ORGANIZATIONS_LIST",
    payload: resp
  };
};

export const setCurrentDataUen = uen => {
  return {
    type: "SET_CURRENT_DATA_UEN",
    uen: uen
  };
};

export const setOrganizationListPaginationPage = pageNumber => {
  return {
    type: "SET_ORGANIZATIONS_LIST_PAGINATION_PAGE",
    pageNumber
  };
};

export const setOrganizationListPageSize = pageSize => {
  return {
    type: "SET_ORGANIZATIONS_LIST_PAGE_SIZE",
    pageSize
  };
};

export const setOrganizationSelectedItem = selected => {
  return {
    type: "SET_ORGANIZATIONS_SELECTED_ITEM",
    selected
  };
};

export const setSelectPrincipalDashboard = selected => {
  return {
    type: "SET_SELECTED_PRINCIPAL_DASHBOARD",
    payload: selected
  };
};

export const saveAssociationDashboard = resp => {
  return {
    type: "SAVE_ASSOCIATION_DASHBOARD",
    payload: resp
  };
};

export const setOrganizationListFilterTitle = title => {
  return {
    type: "SET_ORGANIZATIONS_LIST_FILTER_TITLE",
    title
  };
};

export const initOrganizationListFilter = () => {
  return {
    type: "INIT_ORGANIZATION_LIST_FILTER"
  };
};

export const setOrganizationListFilterType = societyType => {
  return {
    type: "SET_ORGANIZATIONS_LIST_FILTER_TYPE",
    societyType
  };
};

export const setOrganizationListFilterConfigState = configState => {
  return {
    type: "SET_ORGANIZATIONS_LIST_FILTER_CONFIG_STATE",
    configState
  };
};

export const setOrganizationListFilterYear = year => {
  return {
    type: "SET_ORGANIZATIONS_LIST_FILTER_YEAR",
    year
  };
};

export const setOrganizationListFilterPresentations = presentationState => {
  return {
    type: "SET_ORGANIZATIONS_LIST_FILTER_PRESENTATIONS",
    presentationState
  };
};

export const setOrganizationListSortMetrics = sort => {
  return {
    type: "SET_ORGANIZATIONS_LIST_SORT_METRICS",
    sort
  };
};

export const setOrganizationListFilterJuridicalForm = juridicalForm => {
  return {
    type: "SET_ORGANIZATIONS_LIST_FILTER_JURIDICAL_FORM",
    juridicalForm
  };
};

export const setOrganizationJuridicalFormSuggestions = payload => {
  return {
    type: "FETCH_ORGANIZATIONS_JURIDICAL_FORM_SUGGESTIONS",
    payload
  };
};

export const fetchAssociationDashboard = payload => {
  return {
    type: "FETCH_ASSOCIATION_DASHBOARD",
    payload
  };
};

export const setClientCRMType = clientCRMTypes => {
  return {
    type: "SET_CLIENT_CRM_TYPE",
    clientCRMTypes
  };
};

export const setClientCRMGroup = clientCRMGroup => {
  return {
    type: "SET_CLIENT_CRM_GROUP",
    clientCRMGroup
  };
};

export const setFilterCollaborators = collaborators => {
  return {
    type: "SET_FILTER_COLLABORATOR",
    collaborators
  };
};

export const setFilterRoleCollaborators = roleCollaborator => {
  return {
    type: "SET_FILTER_ROLE_COLLABORATOR",
    roleCollaborator
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/data.js